import { GlobalStatus, JobTypesEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsEnum } from "class-validator";

export class SoInvoiceDetailsInfo {
  @ApiProperty()
  invDetailsId?: number;

    @ApiProperty()

    saleOrderId?: number;
    @ApiProperty()
    
    poNumber: string;

    @ApiProperty()
    
    buyerPoNumber: string;
    @ApiProperty()
    
    invoiceDate: Date;
    @ApiProperty()
    
    edaDate: Date;
    @ApiProperty()
    
    edlDate: Date;
    @ApiProperty()
    
    actualEdldate: Date;
    @ApiProperty()
    
    cusAddress: string;
    @ApiProperty()
    
    delAddress: string;
    @ApiProperty()
    
    deliveryTerms: number;
    @ApiProperty()
    
    endCustomerId: number;
    @ApiProperty()
    customerId?: number;
    @ApiProperty()
    
    country: number;
    @ApiProperty()
    
    destination: number;
    @ApiProperty()
    
    payTermId: number;
    @ApiProperty()
    
    shipmentTerms: number;
    @ApiProperty()

    portOfEntry:number;
    @ApiProperty()
    currency:number;
    @ApiProperty()
    unit:number;
    @ApiProperty()
    category:string;
    @ApiProperty()

  salePersonId: number;

  @ApiProperty({enum:Object.values(JobTypesEnum)})
  @IsEnum(JobTypesEnum)
  jobType: JobTypesEnum; 
  @ApiProperty({enum:Object.values(GlobalStatus)})
  @IsEnum(GlobalStatus)
  isSubContract: GlobalStatus; 
  @ApiProperty()
  processingUnit:number;

    


    /**
    * @param saleOrderId
    * @param poNumber
    * @param invoiceDate
    * @param edaDate
    * @param edlDate
    * @param cusAddress
    * @param delAddress
    * @param deliveryTerms
    * @param endCustomerId
    * @param CustomerId
    * @param country
    * @param destination
    * @param payTermId
    * @param shipmentTerms
    *  * @param portOfEntry
    * @param currency
    * @param unit
    * @param category
    * * @param salePersonId
    * 
     */
    constructor(saleOrderId: number, poNumber: string, invoiceDate: Date, edaDate: Date, edlDate: Date, cusAddress: string, delAddress: string, deliveryTerms: number, endCustomerId: number, customerId: number, country: number, destination: number, payTermId: number, shipmentTerms: number, createdUser: string,portOfEntry:number,currency:number,unit:number,category:string,salePersonId:number) {
        this.saleOrderId = saleOrderId;
        this.poNumber = poNumber;
        this.invoiceDate = invoiceDate;
        this.edaDate = edaDate;
        this.edlDate = edlDate;
        this.cusAddress = cusAddress;
        this.delAddress = delAddress;
        this.deliveryTerms = deliveryTerms;
        this.endCustomerId = endCustomerId;
        this.customerId = customerId;
        this.country = country;
        this.destination = destination;
        this.payTermId = payTermId;
        this.shipmentTerms = shipmentTerms;
        this.portOfEntry = portOfEntry;
        this.currency = currency;
        this.unit = unit;
        this.salePersonId = salePersonId;
        this.category = category;
        
    }
}


